<template>
	<component :is="tag" v-if="hasList" class="fd-ea-list">
		<template v-for="(ea, idx) in list">
			<template v-if="idx>0">, </template>
			<ea-action class="fd-ea" :value="ea.value" :raw="ea.raw">{{ ea.value }}</ea-action>
		</template>
	</component>
</template>

<script setup lang="ts">
import {computed} from "vue";
import type {EAddress} from "@t/customer/EAddress";
import EaAction from "../eaddress/EaAction.vue";

const props = withDefaults(defineProps<{
	list: EAddress[],
	tag?: string
}>(), { tag: "div" });

const hasList = computed(() => Array.isArray(props.list) && props.list.length > 0);

</script>

<style>
.fd-ea-list {
	font-size: var(--font-size-s);
	user-select: text;
	-webkit-user-select: text;
}

.fd-ea {
	white-space: nowrap;
}
</style>
